import React from 'react';
import Panel from './Panel';
import BackOfficeList from '../../components/Panel/BackOffice/BackOfficeList';



const BackOfficePage = () => {

  return (
    <Panel>
      <div>
        <p className="title_panel_plans">LISTA DE BACKOFFICE</p>
        <BackOfficeList />

      </div>
    </Panel>

  );
};

export default BackOfficePage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/BackOfficePage.js
 **/